export  const productsDescription = [
  {
    slug: 'sportsbook',
    description: 'A complete Sportsbook platform with live and pre-match betting'
  },
  {
    slug: 'virtualSports',
    description: 'Real-money betting on various 3D-designed sports'
  },
  {
    slug: 'statistics',
    description: 'A wide range of sports information based on historical and near-live data'
  },
  {
    slug: 'liveSports',
    description: 'Exclusive live or on-demand video streaming for players and bookmakers'
  },
  {
    slug: 'poker',
    description: 'Poker games with intuitive design and highly-customisable settings'
  },
  {
    slug: 'skillGames',
    description: 'A traditional casino alternative with Chinese Poker, Backgammon, and Belote'
  },
  {
    slug: 'casinoSuite',
    description: '7,000 casino games from BetConstruct and other major suppliers'
  },
  {
    slug: 'liveCasino',
    description: 'A high-quality and competitively priced gateway with new generation famous casino and hybrid games'
  },
  {
    slug: 'springPro',
    description: 'Your traders. Your risk managers. Your players. Our technology'
  },
  {
    slug: 'betFights',
    description: 'Challenge your knowledge with the world’s first intellectual gaming environment'
  },
  {
    slug: 'friendShip',
    description: 'Real-time quality data and digital content to be booked'
  },
  {
    slug: 'backgammon',
    description: '7 game variations. Multi-platform experience. User-friendly design. Highly-customisable settings.'
  },
  {
    slug: 'bettingGames',
    description: 'The best of in-house developed and 3rd party games from BetConstruct for your iGaming business'
  },
  {
    slug: 'oddsFeed',
    description: 'High frequency odds updates, fixture checks and change alerts'
  },
  {
    slug: 'liveMonitor',
    description: 'All sports events and their markets exclusively displayed in one place.'
  },
  {
    slug: 'terminal',
    description: 'C#-technology self-service betting terminal software for your WindowsOS cabinets and hardware.'
  },
  {
    slug: 'betShopClient',
    description: 'Take bets, pay off bets, register clients, accept deposits and process withdrawal requests.'
  },
  {
    slug: 'betShopPocket',
    description: 'Sortable AndroidOS software to help agents serve players.'
  },
  {
    slug: 'socialGaming',
    description: 'Custom-built social games with unforgettable casino experience.'
  },
  {
    slug: 'liveScoutData',
    description: 'Live Scouting Data provides fast and reliable live data for popular sports from all over the world.'
  },
  {
    slug: 'bettingGames',
    description: 'BetConstruct in-house-developed and 3rd-party games for your iGaming business.'
  },
]
